import { NgFor, NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { Istanza, IstanzeService } from 'app/services/istanze.service';
import { delay } from 'rxjs';

@Component({
  selector: 'stepper-rating',
  template: `
    <div class="flex flex-col w-full h-full">

    <mat-horizontal-stepper aria-label="Valutazione" title="Valutazione"  role="tablist">

      <mat-step *ngFor="let step of field.fieldGroup; let index = index; let last = last">

        <formly-field [field]="step"></formly-field>

        <div class="flex place-content-center mt-4 gap-4" *ngIf="!last">
          <button type="button" mat-stroked-button class="rounded-md text-primary bg-text" color="'primary'" matStepperPrevious *ngIf="index !== 0" > Indietro </button>

          <button (click)="onClick(index)" type="button" mat-stroked-button matStepperNext class="rounded-md bg-primary text-white font-semibold" color="'primary'" [disabled]="!isValid(step)">
            Avanti
          </button>

        </div>

      </mat-step>

    </mat-horizontal-stepper>


    </div>
  `,
  standalone: true,
  imports: [MatStepperModule, NgFor, MatButtonModule, ReactiveFormsModule, FormlyModule, NgIf],
  styles:[
    `
    .mat-stepper-horizontal{

      --mat-stepper-line-color: rgba(255,255,255, 0.9);
    }

    `
  ],
})
export class StepperFormlyRating extends FieldType implements OnInit{


    private _istanzeService = inject(IstanzeService);
    private istanza:Istanza;
    stepIndex: number=0;


  ngOnInit(): void {
    this._istanzeService.istanza$.subscribe(istanza=>this.istanza=istanza)
  }


  onClick(index:number){
    this.field.options.formState.stepIndex = index
    if (index==1){ //invio i dati al server
        if (this.istanza){
            this._istanzeService.updateIstanza({id:this.istanza.id, stars:this.model.rating}, false).pipe(
              delay(3000)
            ).subscribe()
        }
    }
  }

  isValid(field: FormlyFieldConfig): boolean {
    return true
  }
}
